// -------------------------------------
// SlickSlider
// -------------------------------------

(function($) {

  $(document).ready(function() {
    //$(document).on('ready smoothstate', function() {

    $(".slick-slider").on("init", function(event, slick) {
      $(".slick-slide").matchHeight();
    });

    // Slick Slider
    $(".slick-slider").slick({
      autoplay: true,
      autoplaySpeed: 10000,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      // responsive: [{
      //     breakpoint: 991,
      //     settings: {
      //       slidesToShow: 2,
      //       slidesToScroll: 1
      //     }
      //   },
      //   {
      //     breakpoint: 767,
      //     settings: {
      //       slidesToShow: 1,
      //       slidesToScroll: 1
      //     }
      //   }
      // ]
    });

    // Slick Marquee
    $(".slick-marquee").slick({
      autoplay: true,
      autoplaySpeed: 3000,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: false,
      responsive: [{
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 540,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    });

  });

})(jQuery);